<ui-modal
    id="modalUploadShape"
    width="80vw"
>
    <i modalIcon class="pi pi-upload"></i>

    <h3 modalTitle>Upload de shapes</h3>

    <ui-card modalContent shape="square">
        <ui-alert variant="info" label="Importando shapes">
            Para realizar a importação de um shape é necessário que ele esteja em um arquivo no formato JSON ou GeoJSON.
        </ui-alert>

        <div class="d-flex gap-20">
            <div class="position-relative d-flex flex-1">
                <ui-card cardTitle="Shapes importados" variant="internal" shape="square" display="full-space">
                    <div class="position-absolute h-100 w-100">
                        <table ui-table [loading]="loadingShapes">
                            <thead>
                            <tr>
                                <td class="text-center col-1">
                                    #
                                </td>
                                <td class="col-9">
                                    Nome
                                </td>
                                <td class="text-center col-2">
                                    <i class="fa fa-cogs"></i>
                                </td>
                            </tr>
                            </thead>
                            <tbody>
                                @for (area of affectedAreas; track area.id; let i = $index) {
                                    <tr>
                                        <td class="text-center col-1">
                                            {{ i + 1 }}
                                        </td>
                                        <td class="col-9">
                                            {{ area.name }}
                                        </td>
                                        <td class="text-center col-2">
                                            <ui-button
                                                variant="outline"
                                                color="secondary"
                                                [loading]="area['loading']"
                                                (click)="downloadShape(area)"
                                            >
                                                <i class="fa fa-download"></i>
                                            </ui-button>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </ui-card>
            </div>
            <div class="d-flex gap-10 flex-column flex-1">
                <app-material-input label="Nome">
                    <input class="form-control form-control-sm" [(ngModel)]="nome">
                </app-material-input>

                <div class="p-12px">
                    <app-upload-files
                        [extensoesPermitidas]="['json', 'geojson']"
                        [maxArquivos]="1"
                        [tamanhoMaximoPorArquivo]="0"
                        (onEmitFiles)="onFileSelected($event)"
                    ></app-upload-files>
                </div>
            </div>
        </div>
    </ui-card>

    <ui-button
        modalAction
        variant="outline"
        modal-toggle
        width="100%"
    >
        fechar
    </ui-button>
    <ui-button
        modalAction
        width="100%"
        [disabled]="(!nome || !shape)"
        [loading]="loading"
        (click)="submit()"
    >
        <i class="fa fa-upload"></i>
        Importar
    </ui-button>
</ui-modal>

